<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <intern-only-access-redirect-card v-if="!isIntern"/>

    <template v-else>
      <layout-panel :collapse="true">
        <template slot="header">搜索</template>
        <el-form :model="search"
                 label-width="96px"
                 label-position="right"
                 size="medium"
                 @submit.native.prevent="onSearch()"
                 ref="searchForm">
          <div class="re-el-form__flex">
            <el-form-item label="客户"
                          prop="keyword">
              <el-input placeholder="请输入客户名称/编号搜索"
                        v-model="search.keyword"
                        clearable></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       native-type="submit"
                       size="mini">搜索
            </el-button>
            <el-button @click="resetSearch()"
                       size="mini">重置
            </el-button>
          </el-form-item>
        </el-form>
      </layout-panel>

      <layout-panel>
        <template slot="header">列表</template>
        <template slot="tools">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-refresh"
                     @click="onRefresh()"></el-button>
        </template>

        <el-table :data="table"
                  stripe
                  highlight-current-row
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="客户ID"
                           min-width="120"></el-table-column>
          <el-table-column prop="name"
                           label="客户名称"
                           min-width="120"></el-table-column>
          <el-table-column prop="number"
                           label="客户编号"
                           min-width="200"></el-table-column>
          <el-table-column prop="pending_review"
                           label="待审核"
                           min-width="100"
                           align="center"></el-table-column>
          <el-table-column prop="review_failed"
                           label="审核未通过"
                           min-width="120"
                           align="center"></el-table-column>
          <el-table-column prop="closed"
                           label="已关闭"
                           min-width="100"
                           align="center"></el-table-column>
          <el-table-column prop="review_passed"
                           label="审核通过"
                           min-width="100"
                           align="center"></el-table-column>
          <el-table-column label="操作"
                           min-width="120"
                           align="center">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="gotoProjectOrderReviewTable(scope.row)">查看项目
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total">
          </el-pagination>
        </div>
      </layout-panel>
    </template>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import { mapState } from 'vuex'
import InternOnlyAccessRedirectCard from '@/components/InternOnlyAccessRedirectCard.vue'

export default {
  mixins: [table],
  components: {
    InternOnlyAccessRedirectCard,
  },
  computed: {
    ...mapState({
      user: state => state.login.user,
    }),
    isIntern () {
      return parseInt(this.user && this.user.usertype) === 4
    },
  },
  data () {
    return {
      search: {
        customerid: '',
        keyword: '',
      },
    }
  },
  methods: {
    ...request.map([
      'getBasicCustomerTable',
      'getBasicCustomerDetail',
      'getBaiscProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      if (!this.isIntern) {
        return Promise.resolve({
          data: {
            data: [],
            current_page: params.current_page || 1,
            per_page: params.per_page || 50,
            total: 0,
          },
        })
      }
      // 转换搜索参数为接口需要的格式
      const requestParams = {
        customerid: params.customerid || '',
        keyword: params.keyword || '',
        current_page: params.current_page || 1,
        per_page: params.per_page || 50,
      }
      // 移除空字符串参数
      Object.keys(requestParams).forEach(key => {
        if (requestParams[key] === '') {
          delete requestParams[key]
        }
      })
      return request.page('getCustomerOrderReviewTableApi', requestParams)
    },
    gotoProjectOrderReviewTable (row) {
      this.$router.push({
        path: '/customer/project-order-review/table?customerid=' + row.id,
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/customer/pages/CustomerOrderReviewTable.vue